function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-408.000000, -3844.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 2
}, React.createElement("g", {
  transform: "translate(408.000000, 3701.000000)"
}, React.createElement("g", {
  id: "ubicacion-01",
  transform: "translate(0.000000, 135.000000)"
}, React.createElement("path", {
  d: "M5.00025962,9.92392644 C7.62125282,14.2976813 9,17.2878154 9,18.9112451 C9,20.0423637 8.55081899,21.0671609 7.82223405,21.8086789 C7.09996137,22.5437726 6.10258542,22.9999995 5,22.9999995 C3.89741458,22.9999995 2.90003863,22.5437726 2.17776595,21.8086789 C1.44918101,21.0671609 1,20.0423637 1,18.9112451 C1,17.287706 2.37893287,14.2972786 5.00025962,9.92392644 Z",
  id: "gota"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 10 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/small_drop.2c8ad564.svg";
export { SvgComponent as ReactComponent };